function Intro() {
  return (
    <>
      <div
       className="alert alert-success">
        <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>
          <b>موقع "احسب" : أكبر موقع عربي للآلات الحاسبة المجانية على الإنترنت</b>
        </h1>
        <p>
          موقع "احسب" هو المنصة العربية الرائدة التي توفر لك مجموعة شاملة من الآلات الحاسبة المجانية عبر الانترنت لمساعدتك في اجراء حسابات بسرعة ودقة في مجال التمويل، واللياقة البدنية، والصحة، والتعليم والرياضيات و الجبر، وحساب المثلثات، والكسور، والفيزياء، والإحصاء، والتكنولوجيا، وادارة الوقت والمزيد.
        </p>
      </div>
      <hr />
    </>
  )
}
export default Intro;